import React from 'react'
import WeatherList from '../../../../Components/WeatherWidget/WeatherList'
import CountryPage from '../index'
import { LayoutDashboard } from '../../../../Components/Layout/Dashboard'

const Weather = props => {
  return (
    <CountryPage
      country={props.country}
      breadcrumbs={[
        {
          label: 'Pipeline',
        },
      ]}
    >
      <LayoutDashboard>
        <WeatherList cities={props.cities} />
      </LayoutDashboard>
    </CountryPage>
  )
}

export default Weather
